var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCloseIconWhite = function SvgCloseIconWhite(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6716 5.32859C18.9457 5.60264 18.9457 6.04696 18.6716 6.32102L6.32077 18.6719C6.04672 18.9459 5.60239 18.9459 5.32834 18.6719C5.05429 18.3978 5.05429 17.9535 5.32834 17.6795L17.6792 5.32859C17.9533 5.05453 18.3976 5.05453 18.6716 5.32859Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.32834 5.32859C5.60239 5.05453 6.04672 5.05453 6.32077 5.32859L18.6716 17.6795C18.9457 17.9535 18.9457 18.3978 18.6716 18.6719C18.3976 18.9459 17.9533 18.9459 17.6792 18.6719L5.32834 6.32102C5.05429 6.04696 5.05429 5.60264 5.32834 5.32859Z",
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCloseIconWhite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "close-icon-white.0eb94b3572685da16674e5cfadcde14c.svg";